import { Checkbox } from "@nextui-org/react";
const promocodesrecallcolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "subscriptionName",
    label: "Subscription Name",
  },
 
  {
    key: "typeValue",
    label: "Discount",
  },
  {
    key: "usage",
    label: "Usage",
  },
  {
    key: "expiryDate",
    label: "Expiry",
  },
  {
    key: "usageLimit",
    label: "Total",
  },
  {
    key: "promoUsedRecall",
    label: "Used",
  },
  {
    key: "type",
    label: "Type",
  },
  {
    key: "actions",
    label: "Actions",
  },
];
export { promocodesrecallcolumn };
